/**
 * Endereços das páginas de conteúdo (serviços, guias e institucionais).
 * Lista leve para o roteador; o texto de cada página fica em src/content/pages e só é
 * baixado quando a página abre. O teste e a pré-renderização conferem se as duas listas batem.
 */
export const contentPaths = [
  '/consulta-placa',
  '/consulta-veicular-completa',
  '/consulta-gravame',
  '/consulta-leilao',
  '/consulta-multas-prf',
  '/consulta-placa-gratis',
  '/guias/checklist-carro-usado',
  '/guias/o-que-e-gravame',
  '/guias/como-consultar-multas-pela-placa',
  '/sobre',
  '/contato',
  '/termos-de-uso',
  '/politica-de-privacidade',
] as const
